// extracted by mini-css-extract-plugin
module.exports = {"input":"TextArea_input__6ih1L","wrapper":"TextArea_wrapper__Zg6Je","container":"TextArea_container__KH2A0","errorTag":"TextArea_errorTag__DfwKJ"};